module.exports = __webpack_public_path__ + "img/952.cb27d378.png";